import { useContext } from "react";
import { DirectionContext, isDirection } from "./contexts";
export const useDirection = (dir) => {
    const contextDirection = useContext(DirectionContext);
    if (dir && isDirection(dir)) {
        return dir;
    }
    return contextDirection || (isDirection(document.dir) && document.dir) || "ltr";
};
//# sourceMappingURL=useDirection.js.map